export default {
  title: 'Planos',
  description: 'Gerencie os planos de assinatura.',
  labels: {
    new: 'Novo Plano',
  },
  fields: {
    name: 'Nome do Plano',
    max_depth: 'Limite de itens',
    has_services: 'Serviços',
    has_products: 'Produtos',
    has_blog: 'Possui Blog',
    is_active: 'Ativo',
    is_managed: 'Gerenciado',
    options: 'Opções',
  }
};
